import React, { PureComponent } from 'react';
import { createPortal } from 'react-dom';
import { Row, Col, Button } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import Skeleton from 'react-skeleton-loader';

import { checkRole } from '../../helpers';
import { ROLE_EVO_SB_ADMIN, APPLICATION_ROOT, HELLO_SIGN_ID } from '../../constants';
import { ChangeEsignatureTier, CenteredModal } from '../../components';
import {
  getTenantEsignatureData, getCompany, GET_TENANT_ESIGNATURE_DATA,
  LOADING_PROP_TYPE, GET_USER_ROLES, GET_COMPANY,
} from '../../modules';

import './CompanyPlan.scss';

class CompanyPlan extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      target: document.getElementById('companyplan-ui'),
      isModalOpen: false,
    };
  }

  componentDidMount() {
    const selectedCompanyId = get(window, 'asure.appSettings.selectedCompany.companyId');
    const { intl: { formatMessage } } = this.props;

    if (this.state.target) {
      this.props.getCompany(selectedCompanyId, formatMessage);
      this.props.getTenantEsignatureData(formatMessage);
    }
  }

  toggleModal() {
    this.setState({ isModalOpen: !this.state.isModalOpen });
  }

  render() {
    const { target } = this.state;
    const {
      esignaturePricingData,
      isDirectClient,
      isSBAdminOrAbove,
      selectedCompany,
    } = this.props;

    const isLoading =
      this.props.loading[GET_TENANT_ESIGNATURE_DATA] === 'loading' ||
      this.props.loading[GET_USER_ROLES] === 'loading' ||
      this.props.loading[GET_COMPANY] === 'loading';
    const showPriceInfo = isSBAdminOrAbove || isDirectClient;
    const companyIsHelloSign =
      selectedCompany && selectedCompany.esignatureProductTier && selectedCompany.esignatureProductTier.id === HELLO_SIGN_ID;
    const componentContent = (
      <Row>
        <CenteredModal
          style={{ margin: '10rem auto', maxWidth: '752px' }}
          isOpen={this.state.isModalOpen}
          parentselector={APPLICATION_ROOT}
          toggle={() => this.setState({ isModalOpen: !this.state.isModalOpen })}
          backdrop
        >
          <ChangeEsignatureTier
            isHelloSignEnabled={companyIsHelloSign}
            isLegacy={selectedCompany.isEsignatureLegacyCompany}
            esignaturePricingData={esignaturePricingData}
            onClose={() => this.toggleModal()}
          />
        </CenteredModal>
        <div className="col-sm-12">
          <h5><FormattedMessage id="ADD_ONS" /></h5>
          <h6><FormattedMessage id="CUSTOMIZE_PLAN" /></h6>
          <div className="company-plan-table">
            <Row className="header-row hide-for-mobile mx-0 w-100">
              <div className="col-sm-6 table-cell"><div className="my-auto"><FormattedMessage id="ADDON" /></div></div>
              <div className="col-sm-6 table-cell"><div className="my-auto"><FormattedMessage id="COST" /></div></div>
            </Row>
            {isLoading ?
              <Row className="body-row d-flex pt-2 pb-4 mx-0 w-100">
                <div className="col-sm-6">
                  <Row className="d-flex pl-3 pt-1">
                    <Skeleton class="ml-auto" width="350px" height="24px" borderRadius="0" color="#ededed" count={2} />
                  </Row>
                </div>
                <div className="col-sm-4 cost-section d-flex align-items-center">
                  <div>
                    <Skeleton class="ml-auto" width="250px" height="24px" borderRadius="0" color="#ededed" count={2} />
                  </div>
                </div>
                <Col className="d-flex col-sm-2">
                  <Skeleton class="ml-auto" width="100px" height="24px" borderRadius="0" color="#ededed" widthRandomness="0" />
                </Col>
              </Row>
              :
              <Row className="body-row d-flex pt-2 pb-4 mx-0 w-100">
                <div className="col-sm-6">
                  <Row className="d-flex pl-3 pt-1">
                    <strong><FormattedMessage id="ENHANCED_ESIGNATURE" /></strong>
                    <div className={`${!companyIsHelloSign ? 'd-none' : 'enabled-tag'}`}><FormattedMessage id="ENABLED" /></div>
                  </Row>
                  <Row className="pl-3 text-faded">
                    <div>
                      <FormattedMessage id="ENHANCED_ESIGNATURE_DESC" />
                      &nbsp;
                      <div className="btn-link d-inline">
                        <a href={isDirectClient ? 'https://www.asuresoftware.com/enhanced-esignature' : 'https://www.asuresoftware.com/partner-enhanced-esignature'} target="_blank" rel="noopener noreferrer">
                          <FormattedMessage id="LEARN_MORE" />
                        </a>
                      </div>
                    </div>
                  </Row>
                </div>
                <div className="col-sm-4 cost-section d-flex align-items-center">
                  {showPriceInfo ?
                    <div>
                      <Row className="pt-3 show-for-mobile"><div className="small"><FormattedMessage id="COST" /></div></Row>
                      <Row>
                        <strong>${esignaturePricingData.costPerRequest} <FormattedMessage id="PER_SIGNATURE_REQUEST" /></strong>
                      </Row>
                      <Row><div>+ ${esignaturePricingData.monthlyCost} <FormattedMessage id="PER_MONTH_BASIS" /></div></Row>
                    </div>
                  :
                    <Row className="pt-1"><div><FormattedMessage id="CONTACT_CUSTOMER_SERVICE_FOR_ADD_ON" /></div></Row>
                  }
                </div>
                <Col className="col-xs-12 col-sm-2 d-flex align-items-center pt-2 button-col">
                  <Button className={`${!showPriceInfo ? 'd-none' : 'd-flex'}`} color="primary" onClick={() => this.toggleModal()}>
                    {!companyIsHelloSign ?
                      <FormattedMessage id="ENABLE" />
                    :
                      <FormattedMessage id="DISABLE" />
                  }
                  </Button>
                </Col>
              </Row>
              }
          </div>
        </div>
      </Row>
    );
    if (target) {
      return createPortal(componentContent, target);
    }
    return null;
  }
}

CompanyPlan.defaultProps = {
  isSBAdminOrAbove: false,
};

CompanyPlan.propTypes = {
  getTenantEsignatureData: PropTypes.func.isRequired,
  esignaturePricingData: PropTypes.shape({
    monthlyCost: PropTypes.string,
    costPerRequest: PropTypes.string,
  }).isRequired,
  isDirectClient: PropTypes.bool.isRequired,
  isSBAdminOrAbove: PropTypes.bool,
  getCompany: PropTypes.func.isRequired,
  selectedCompany: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    esignatureProductTier: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    isEsignatureLegacyCompany: PropTypes.bool,
  }).isRequired,
  loading: LOADING_PROP_TYPE.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
};

export default connect(
  (state) => {
    const { user: { roles }, appState: { loading } } = state;

    return {
      esignaturePricingData: state.resources.tenants.pricingData,
      isDirectClient: state.resources.tenants.isDirectClient,
      isSBAdminOrAbove: checkRole(roles, ROLE_EVO_SB_ADMIN),
      roles,
      selectedCompany: state.resources.companies.selectedCompany,
      loading,
    };
  },
  dispatch => ({
    getCompany: (selectedCompanyId, formatMessage) => dispatch(getCompany(selectedCompanyId, formatMessage)),
    getTenantEsignatureData: formatMessage => dispatch(getTenantEsignatureData(formatMessage)),
  })
)(injectIntl(CompanyPlan));




// WEBPACK FOOTER //
// ./src/containers/CompanyPlan/CompanyPlan.jsx